/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Alert, Button, Drawer, Icon, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import usePortal from "react-useportal";
import MapPropsContext from "../MapPropsContext";
import { getListWithSecureZone } from "../../../api";
import { getLastDomByClassName } from "../../../utils";
import { StyledButton } from "../../../styled-components/Button";
import StyledTableHeader from "../../../styled-components/StyledTableHeader";
import { Divider } from "rc-menu";

const WidgetTableForSecureZone = ({ getTitle, columns, fetchUrl, horizontalScroll, verticalScrollvisible, visible,setVisible, widgetTabIndex}) => {
  const openDrawerButtonRef = useRef();

  const { filteredPointsResponseList, pointsResponseList, clickedPointIconObjects } = useContext(MapPropsContext);

  const district_code = useMemo(() => {
    if (pointsResponseList.length > 0) {
      return pointsResponseList[0][0]["district_code"];
    }
  }, [pointsResponseList]);

  const [detailObjects, setDetailObjects] = useState();
  // const [visible, setVisible] = useState(false);
  const [error, setError] = useState();

  const [isDownloading, setIsDownloading] = useState(false);

  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const [sortedInfo, setSortedInfo] = useState({});
  const newColumns = useMemo(() => {
    return columns.map((column) => {
      const { dataIndex } = column;
      const { columnKey, order } = sortedInfo || {};
      const sortOrder = columnKey === dataIndex && order;
      return {
        ...column,
        sortOrder,
      };
    });
  }, [columns, sortedInfo]);

  // 테이블의 변경정보를 관련 상탯값에 반영합니다.
  const onChangeTable = useCallback((pagination, filters, sorter) => {
    setSortedInfo(sorter);
  }, []);

  // 첫번째 레이어만을 보여줬습니다.
  const rowsInFirstLayer = filteredPointsResponseList.length > 0 ? filteredPointsResponseList[0] : [];

  const uidArray = useMemo(() => {
    return rowsInFirstLayer.map(({ uid }) => uid);
  }, [filteredPointsResponseList]);

  //// 페이지네이션을 위한 변수 추가
  const [totalCount, setTotalCount] = useState(0);
  const [curPage, setCurPage] = useState(1);
  const [pageSize, setPageSize] = useState(7);
  useEffect(() => {
    if (!visible) {
      setDetailObjects(undefined);
      setSortedInfo(null);
      setPageSize(20);
      setCurPage(1);
    } else if (visible && fetchUrl) {
      getListWithSecureZone({
        relUrl: fetchUrl,
        uidArray,
        district_code,
        curPage: curPage,
        pageSize: pageSize,
      })
        .then(({ data }) => {
          setTotalCount(data.totalCount);
          setDetailObjects(data.data); // data(response)에서 data객체 참조
        })
        .catch((e) => {
          setError(e);
        });
    }
  }, [visible, uidArray, fetchUrl, district_code, curPage, pageSize]);

  useEffect(() => {
    // 딜레이를 주어, 보다 자연스럽게 Drawer창을 끕니다.
    if (clickedPointIconObjects && clickedPointIconObjects.length > 0 && visible) {
      setTimeout(() => {
        setVisible(false);
      }, 200);
    }
  }, [clickedPointIconObjects]);

  const downloadXlsx = useCallback(() => {
    setIsDownloading(true);
    getListWithSecureZone({
      relUrl: fetchUrl,
      uidArray,
      district_code,
      isExcelDownload: true,
    })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  }, [uidArray, fetchUrl, district_code]);

  const { Portal } = usePortal({
    bindTo: getLastDomByClassName("toolbar-show-list"),
  });

  const changePagination = (page) => {
    setCurPage(page);
  };

  const chanePageSize = (current, size) => {
    setCurPage(1);
    setPageSize(size);
  };

  return (
    <>
      <Portal>
        <StyledButton
          isActive={visible}
          // type={visible ? "primary" : undefined}
          onClick={() => setVisible(true)}
          // tabIndex={TI_SHOW_LIST_BUTTON}
          tabIndex={widgetTabIndex}
          ref={openDrawerButtonRef}
        >
          목록 보기
        </StyledButton>
      </Portal>

      <Drawer
        // title={getTitle(rowsInFirstLayer)}
        placement={"bottom"}
        height={300 + 160}
        closable={false}
        onClose={() => setVisible(false)}
        bodyStyle={{ padding: 12, overflowX: "scroll" }}
        visible={visible}
      >
        {!fetchUrl && <Alert type="error" message="fetchUrl 미등록" />}
        {fetchUrl && (
          <>
            <StyledTableHeader>
              <span>{getTitle(rowsInFirstLayer)}</span>
              <div>
                <Button
                  onClick={downloadXlsx}
                  style={{ marginRight: 8 }}
                  type="primary"
                  disabled={!fetchUrl || isDownloading}
                >
                  {isDownloading && <Icon type="loading" />}
                  {!isDownloading && <FontAwesomeIcon icon={faFileExcel} />}
                  <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
                </Button>
                <Button
                  onClick={() => {
                    openDrawerButtonRef.current.focus();
                    setVisible(false);
                  }}
                >
                  닫기
                </Button>
              </div>
            </StyledTableHeader>
            <div style={STYLE_CONTENT}>
              {error && <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"} />}
              {!error && (
                <Table
                  dataSource={
                    detailObjects &&
                    detailObjects.map((row, index) => ({
                      index: index + 1,
                      ...row,
                    }))
                  }
                  columns={newColumns}
                  onChange={onChangeTable}
                  size={"small"}
                  rowKey={"index"}
                  bordered={true}
                  loading={!detailObjects && !error}
                  ellipsis={true}
                  scroll={
                    {
                      // x: horizontalScroll || 1200,
                      // y: verticalScroll || 300,
                    }
                  }
                  tableLayout={"fixed"}
                  pagination={{
                    defaultCurrent: curPage,
                    current: curPage,
                    onChange: changePagination,
                    onShowSizeChange: (current, size) => chanePageSize(current, size),
                    pageSize: pageSize,
                    defaultPageSize: pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ["20", "50", "100"],
                    total: totalCount,
                  }}
                />
              )}
            </div>
          </>
        )}
      </Drawer>
    </>
  );
};

const STYLE_CONTENT = {
  height: "100%",
  marginTop: "10px",
};

const STYLE_SUBMIT = {
  // position: "absolute",
  top: 2,
  right: 2,
  padding: "10px 12px",
};

export default WidgetTableForSecureZone;
